export enum TherapyPlanStatusEnum {
  Planned = 'Planned',
  Started = 'Started',
  Finished = 'Finished',
  Canceled = 'Canceled'
}

export const TherapyPlanStatusTranslations = {
  getTranslationByKey: getTranslation
};

function getTranslation(key: string): string {
  switch (key) {
    case TherapyPlanStatusEnum.Planned:
      return 'Geplant';

    case TherapyPlanStatusEnum.Started:
      return 'Gestartet';

    case TherapyPlanStatusEnum.Finished:
      return 'Abgeschlossen';

    case TherapyPlanStatusEnum.Canceled:
      return 'Abgebrochen';

    default:
      return '';
  }
}
